// Dashboard tour guide steps using the specific IDs assigned to card elements
export const dashboardGuideSteps = [
  {
    element: "#dashboard-map-card",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>  
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Map Overview</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">View your total affiliates and their distribution across the world. The map shows the location of your affiliates.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-900 font-medium">Track your total affiliates and their distribution across the world. The map shows the location of your affiliates.</p>
          </div>
        </div>`,
      side: "bottom" as const,
      align: "start" as const,
    },
  },
  {
    element: "#dashboard-map-countries-card",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Countries Coverage</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Track how many countries your affiliates are located in. This shows your global reach and market penetration.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-900 font-medium">Monitor your international presence and identify opportunities for expansion into new markets.</p>
          </div>
        </div>`,
      side: "bottom" as const,
      align: "end" as const,
    },
  },
  {
    element: "#dashboard-map-new-affiliates-card",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">New Affiliates</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">See how many new affiliates joined this month. This metric helps track your recruitment success and growth rate.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-900 font-medium">Monitor your affiliate acquisition efforts and identify which strategies are most effective for attracting new partners.</p>
          </div>
        </div>`,
      side: "bottom" as const,
      align: "end" as const,
    },
  },
  {
    element: "#dashboard-map-total-affiliates-card",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Total Affiliates</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">View your complete affiliate network size. This shows the total number of active affiliates in your program.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-900 font-medium">Track your overall affiliate base growth and retention rates to measure program health and success.</p>
          </div>
        </div>`,
      side: "bottom" as const,
      align: "end" as const,
    },
  },
  {
    element: "#dashboard-campaign-card",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Reveshare Campaigns</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">This tracks the total number of active campaigns currently running and linked to your Reveshare account.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-900 font-medium">Keep an eye on your active campaigns to ensure your marketing efforts are running smoothly.</p>
          </div>
        </div>`,
      side: "left" as const,
      align: "start" as const,
    },
  },
  {
    element: "#dashboard-order-card",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Order Analytics</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">View orders that came through affiliates and the average per affiliate. Once there are a few days of orders, click the figure or "Chart" to see them day by day.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-900 font-medium">Track order performance and identify your most effective affiliates.</p>
          </div>
        </div>`,
      side: "bottom" as const,
      align: "start" as const,
    },
  },
  {
    element: "#dashboard-payout-card",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Affiliate Payouts</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Track total payouts to affiliates and average payout amounts. Monitor payout trends and distribution.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-900 font-medium">Keep track of commission payments and ensure timely payouts to your affiliates.</p>
          </div>
        </div>`,
      side: "bottom" as const,
      align: "start" as const,
    },
  },
  {
    element: "#dashboard-discount-code-card",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Discount Code Usage</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Monitor how often your discount codes are being used. Once there are a few days of activity, click the figure or "Chart" to see uses day by day.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-900 font-medium">Track code performance and identify which codes are most popular with customers.</p>
          </div>
        </div>`,
      side: "bottom" as const,
      align: "start" as const,
    },
  },
  {
    element: "#dashboard-top-affiliate-table",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Latest Affiliate Sales</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">View your highest-performing affiliates with detailed order information, commission earned, and performance metrics.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-900 font-medium">Identify your star performers and learn from their success strategies.</p>
          </div>
        </div>`,
      side: "top" as const,
      align: "start" as const,
    },
  },
];
